import React from 'react';
import { IconCircleCheck, IconCircleX, IconInfoCircle } from '@tabler/icons-react';

const RulesSection = ({ rules }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'do':
        return <IconCircleCheck size={28} color="#ffd700" strokeWidth={2} />;
      case 'dont':
        return <IconCircleX size={28} color="#c41e3a" strokeWidth={2} />;
      default:
        return <IconInfoCircle size={28} color="#00d4ff" strokeWidth={2} />;
    }
  };

  return (
    <section className="ub-rules-section">
      <div className="ub-rules-grid">
        {rules.map((rule, index) => (
          <div key={index} className={`ub-rule-card ub-rule-type-${rule.type || 'ub-info'}`}>
            <div className="ub-rule-header">
              <div className="ub-rule-icon-wrapper">
                {getIcon(rule.type)}
              </div>
              <div className="ub-rule-header-content">
                <div className="ub-rule-number">Rule {index + 1}</div>
                <h3 className="ub-rule-title">{rule.title}</h3>
              </div>
            </div>

            <div className="ub-rule-content">
              {rule.diagram && (
                <div className="ub-rule-diagram">
                  <div className="ub-diagram-label">{rule.diagram.label}</div>
                  <div className="ub-diagram-value">{rule.diagram.value}</div>
                </div>
              )}

              <ul className="ub-rule-list">
                {rule.points.map((point, i) => (
                  <li key={i} className="ub-rule-point">
                    <span className="ub-point-bullet"></span>
                    <span className="ub-point-text">{point}</span>
                  </li>
                ))}
              </ul>

              {rule.keyFact && (
                <div className="ub-rule-key-fact">
                  <span className="ub-key-fact-label">Note From The Athlete:</span>
                  <span className="ub-key-fact-text">{rule.keyFact}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="ub-rules-quick-ref">
        
        <div className="ub-quick-ref-grid">
          <div className="ub-quick-ref-item ub-quick-ref-do">
            <IconCircleCheck size={18} color="#ffd700" />
            <span>Always Do</span>
          </div>
          <div className="ub-quick-ref-item ub-quick-ref-dont">
            <IconCircleX size={18} color="#c41e3a" />
            <span>Never Do</span>
          </div>
          <div className="ub-quick-ref-item ub-quick-ref-info">
            <IconInfoCircle size={18} color="#00d4ff" />
            <span>Good to Know</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RulesSection;
